<template>
  <div class="culture-page">
    <CultureNav />
    <main>
      <v-container>
        <section class="traditions-section">
          <div class="section-heading">
            <h1>Traditions</h1>
            <p>The small rituals and annual celebrations that make Reckon feel like Reckon.</p>
          </div>

          <div class="tradition-stats">
            <CultureStatCard
              :value="chickFilAFridayCount"
              label="Chick-fil-A Fridays"
              :to="{ name: 'reckon-way-tradition', params: { traditionSlug: 'chick-fil-a-friday' } }"
            />
            <CultureStatCard
              value="4"
              label="Anniversary Dinners"
              :to="{ name: 'reckon-way-tradition', params: { traditionSlug: 'anniversary-dinner' } }"
            />
            <CultureStatCard
              value="Many"
              label="Happy Hours"
              :to="{ name: 'reckon-way-tradition', params: { traditionSlug: 'happy-hours' } }"
            />
          </div>

          <section
            v-for="group in traditionGroups"
            :key="group.id"
            class="tradition-group"
          >
            <div class="group-heading">
              <p>{{ group.eyebrow }}</p>
              <h2>{{ group.title }}</h2>
            </div>

            <div class="tradition-cards">
              <CultureCard
                v-for="tradition in group.items"
                :key="tradition.id"
                :title="tradition.name"
                :eyebrow="tradition.eyebrow"
                :summary="tradition.summary"
                :image="tradition.heroImage"
                :metadata="traditionMetadata(tradition)"
                :href="traditionRoute(tradition)"
              />
            </div>
          </section>
        </section>
      </v-container>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/Footer.vue';
import CultureNav from '@/components/reckon-way/culture/CultureNav.vue';
import CultureCard from '@/components/reckon-way/culture/CultureCard.vue';
import CultureStatCard from '@/components/reckon-way/culture/CultureStatCard.vue';
import { traditions } from '@/content/culture/traditions';

export default {
  name: 'TraditionsLandingView',
  components: {
    AppFooter, CultureNav, CultureCard, CultureStatCard,
  },
  data: () => ({ traditions }),
  computed: {
    chickFilAFridayCount() {
      const tradition = this.traditions.find((item) => item.id === 'chick-fil-a-friday');
      return tradition ? String(tradition.occurrenceCount) : '';
    },
    traditionGroups() {
      return [
        {
          id: 'annual',
          title: 'Annual Traditions',
          eyebrow: 'Every Year',
          items: this.traditions.filter((tradition) => tradition.cadence === 'annual'),
        },
        {
          id: 'weekly',
          title: 'Weekly Traditions',
          eyebrow: 'Every Week',
          items: this.traditions.filter((tradition) => tradition.cadence === 'weekly'),
        },
        {
          id: 'recurring',
          title: 'Recurring Traditions',
          eyebrow: 'Whenever the Moment Calls',
          items: this.traditions.filter((tradition) => ['monthly', 'recurring'].includes(tradition.cadence)),
        },
      ];
    },
  },
  methods: {
    traditionRoute(tradition) {
      return tradition.archiveRouteName
        ? { name: tradition.archiveRouteName }
        : { name: 'reckon-way-tradition', params: { traditionSlug: tradition.slug } };
    },
    traditionMetadata(tradition) {
      const metadata = [];
      if (tradition.startDate) metadata.push(`Since ${tradition.startDate.slice(0, 4)}`);
      if (tradition.occurrenceCount) metadata.push(`${tradition.occurrenceCount} occurrences`);
      return metadata;
    },
  },
};
</script>

<style scoped>
.culture-page,
main {
  background: #050505;
}

.culture-page main {
  padding: 36px 0 70px;
}

.traditions-section {
  border-top: 1px solid #252525;
  margin: 24px 0 52px;
  padding-top: 42px;
}

.section-heading {
  margin-bottom: 8px;
}

.section-heading h1 {
  color: #fff;
  font-family: "Oswald", sans-serif;
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 8px;
}

.section-heading p {
  color: #b8b8b8;
  font-size: 1.05rem;
  line-height: 1.45;
  margin: 0;
}

.tradition-stats,
.tradition-cards {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.tradition-stats {
  margin-top: 24px;
}

.tradition-group {
  border-top: 1px solid #292929;
  margin-top: 52px;
  padding-top: 42px;
}

.group-heading {
  margin-bottom: 24px;
}

.group-heading p {
  color: #e23232;
  font-family: "Oswald", sans-serif;
  font-size: .8rem;
  font-weight: 900;
  margin: 0 0 6px;
  text-transform: uppercase;
}

.group-heading h2 {
  color: #fff;
  font-family: "Oswald", sans-serif;
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0;
}

@media (max-width: 600px) {
  .section-heading h1,
  .group-heading h2 {
    font-size: 1.7rem;
  }
}
</style>
